import { HeartPulse, Stethoscope, User, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { Audience } from '@marketing/data/audiences';

const MAP: Record<Audience['iconKey'], LucideIcon> = {
  autist: User,
  caregiver: HeartPulse,
  physician: Stethoscope,
  multidisc: Users,
};

export function AudienceIcon({
  iconKey,
  size = 36,
}: {
  iconKey: Audience['iconKey'];
  size?: number;
}) {
  const Icon = MAP[iconKey];
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 28,
        height: size + 28,
        borderRadius: '50%',
        background:
          'radial-gradient(circle at 35% 30%, var(--color-warm-500) 0%, var(--color-warm-700) 35%, var(--color-brand-800) 100%)',
        color: '#FFFFFF',
        boxShadow: 'var(--shadow-elev2)',
      }}
    >
      <Icon size={size} strokeWidth={1.75} aria-hidden="true" />
    </span>
  );
}
